import React from 'react';
import { MenuItem, Text, MenuDivider, MenuList, } from '@chakra-ui/react';
import { useTokens } from '../../../context/TokenProvider';
import { RenderIf } from '../RenderIf/RenderIf';
import SmartText from '../SmartText/SmartText';
const CustomSelectOptions = ({ groups, onChange, nameField, }) => {
    const tokens = useTokens();
    return (React.createElement(MenuList, { "data-testid": "custom_select_options", bg: "white" }, groups.map((group, groupIndex) => (React.createElement(React.Fragment, { key: group.key ?? groupIndex },
        React.createElement(RenderIf, { condition: !!group.label },
            React.createElement(Text, { "data-testid": "custom_select__group_label", px: tokens.Spacing04, pt: groupIndex !== 0 ? tokens.Spacing05 : tokens.Spacing03, variant: "md-600-rg-3" }, group.label),
            React.createElement(MenuDivider, { mx: tokens.Spacing04, borderColor: tokens.BorderLight500 })),
        group.options.map((option) => (React.createElement(MenuItem, { key: option.id, onClick: () => onChange(option.id, group.key) },
            React.createElement(Text, { isTruncated: true, whiteSpace: "pre-wrap" },
                React.createElement(SmartText, { label: option[nameField] }))))))))));
};
export default CustomSelectOptions;
